export const STATE_LOADING = 'STATE_LOADING'
